import SVGInject from '@iconfu/svg-inject';

const initializeBlock = () => {
    SVGInject(document.querySelectorAll('img.injectable'));
};

document.addEventListener('DOMContentLoaded', function () {
    initializeBlock();
});

if (window.acf) {
    window.acf.addAction(
        'render_block_preview/type=onsc-advertisement',
        initializeBlock
    );
}
